module.exports = __webpack_public_path__ + "img/spc-m.c04236e0.png";